import React from "react";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { about, company } from "../mock";
import useBranding from "../hooks/useBranding";
import { brandText } from "../utils/brand";

const About = () => {
  const [ref, inView] = useReveal();
  const b = useBranding();

  return (
    <section id="about" className="py-20 md:py-28 bg-white overflow-hidden">
      <div ref={ref} className="pp-container grid lg:grid-cols-2 gap-14 items-center">
        {/* Images */}
        <div className={`relative pp-reveal ${inView ? "pp-in" : ""}`}>
          <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_60px_-25px_rgba(13,27,42,0.45)]">
            <img src={about.image1} alt="About PhotonPE" className="w-full h-[430px] object-cover" />
          </div>
          <div className="absolute -bottom-10 right-4 w-52 md:w-64 rounded-2xl overflow-hidden border-8 border-white shadow-xl pp-float">
            <img src={about.image2} alt="PhotonPE technology" className="w-full h-40 object-cover" />
          </div>
          {/* Rotating circle badge */}
          <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-[#0D1B2A] hidden md:flex items-center justify-center shadow-lg">
            <svg viewBox="0 0 100 100" className="w-full h-full pp-spin absolute inset-0">
              <defs>
                <path id="circlePath" d="M50,50 m-34,0 a34,34 0 1,1 68,0 a34,34 0 1,1 -68,0" />
              </defs>
              <text fill="#10B981" fontSize="9" fontWeight="700" letterSpacing="2">
                <textPath href="#circlePath">{brandText("PHOTONPE • FINTECH • PHOTONPE •", b.company_name)}</textPath>
              </text>
            </svg>
            <ArrowRight size={22} className="text-[#06B6D4] relative z-10" />
          </div>
        </div>

        {/* Text */}
        <div className={`pp-reveal ${inView ? "pp-in" : ""}`} style={{ animationDelay: "0.15s" }}>
          <span className="inline-flex items-center gap-2 text-[#06B6D4] font-semibold uppercase tracking-wider text-sm">
            <span className="w-8 h-[2px] bg-[#06B6D4]" /> {about.tag}
          </span>
          <h2 className="mt-4 text-3xl md:text-[44px] font-extrabold leading-[1.12] text-[#0D1B2A]">
            {about.titleLead}
            <span className="pp-grad-text-orange">{about.titleHi}</span>
          </h2>
          <div className="mt-6 rounded-2xl bg-[#050C17] px-5 py-4 border-l-4 border-[#06B6D4]" data-testid="about-legal-name">
            <div className="text-lg md:text-2xl font-extrabold tracking-tight text-white uppercase leading-snug">
              {b.company_name} <span className="text-[#06B6D4]">–</span> <span className="text-slate-400 normal-case font-semibold text-base md:text-lg">A Brand of</span>{" "}
              <span className="pp-grad-text">{company.legalName}</span>
            </div>
          </div>
          <p className="mt-5 text-[#475569] leading-relaxed text-[15.5px]">{brandText(about.body, b.company_name)}</p>
          <button
            onClick={() => document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" })}
            className="group mt-8 inline-flex items-center gap-3 bg-[#0D1B2A] text-white font-semibold pl-7 pr-3 py-3 rounded-full hover:bg-[#06B6D4] transition-colors"
          >
            Read More
            <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <ArrowRight size={16} />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default About;
